// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchAepsBalance, fetchSettlementBalance, fetchWalletBalance } from "../../../Store/Slices/WalletSlice";
// import useApi from "../../../CustomHooks/useApi";

// const Ccbp = () => {
//     const [formData, setFormData] = useState({
//         billerId: "",
//         cardNumber: "",
//         confirmCardNumber: "",
//         mobileNumber: "",
//         amount: "",
//     });

//     const getBillerId = (b) => b.billerId || b.serviceId;

//     const [error, setError] = useState("");
//     const [loading, setLoading] = useState(false);
//     const [success, setSuccess] = useState(false);
//     const [billers, setBillers] = useState([]);
//     const [loadingBillers, setLoadingBillers] = useState(false);
//     const [billerError, setBillerError] = useState("");
//     const { lat, lng } = useSelector((state) => state.location);
//     const [billerDropdownOpen, setBillerDropdownOpen] = useState(false);
//     const [billerSearch, setBillerSearch] = useState("");
//     // const selectedBillerName = billers.find(
//     //     (b) => String(b.billerId) === String(formData.billerId)
//     // )?.bankName;
//     const selectedBillerName = billers.find(
//         (b) => String(getBillerId(b)) === String(formData.billerId)
//     )?.bankName;

//     const [billDetails, setBillDetails] = useState(null);
//     const [billFetched, setBillFetched] = useState(false);
//     const [mpin, setMpin] = useState("");

//     const [paymentResponse, setPaymentResponse] = useState(null);
//     const [responseStatus, setResponseStatus] = useState(null);

//     const [selectedBillerExactness, setSelectedBillerExactness] = useState(null);

//     const [feeDetails, setFeeDetails] = useState(null);
//     const [showFeeConfirmation, setShowFeeConfirmation] = useState(false);

//     const token = useSelector((state) => state.auth.employeeDetails?.token);
//     const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
//     const username = useSelector((state) => state.auth.employeeDetails?.username);
//     const dispatch = useDispatch();

//     const { callApi: fetchcard } = useApi("/creditCard/biller");
//     const { callApi: creditcardaddbill } = useApi("/creditCard/add-bill", "POST");
//     const { callApi: creditcardfetchbill } = useApi("/creditCard/fetch-bill", "POST");
//     const { callApi: calculatefee } = useApi("/dmt/fee/calculate", "POST");

//     useEffect(() => {
//         fetchBillers();
//     }, [token]);

//     useEffect(() => {
//         const handleClickOutside = (e) => {
//             if (!e.target.closest(".biller-dropdown-wrapper")) {
//                 setBillerDropdownOpen(false);
//                 setBillerSearch("");
//             }
//         };
//         document.addEventListener("mousedown", handleClickOutside);
//         return () => document.removeEventListener("mousedown", handleClickOutside);
//     }, []);


//     const fetchBillers = async () => {
//         setLoadingBillers(true);
//         setBillerError("");
//         setBillers([]);

//         try {
//             const response = await fetchcard();

//             // 🔴 HANDLE LOGICAL FAILURE (202)
//             if (
//                 response?.error_code === 202 ||
//                 response?.error === "Accepted"
//             ) {
//                 setBillerError(response.message || "Failed to load billers.");
//                 return;
//             }

//             if (Array.isArray(response) && response.length > 0) {

//                 const filteredBillers = response.filter(
//                     (b) =>
//                         b.bankName &&
//                         ["EZYPAY", "ENKASH", "BOTH"].includes(b.provider)
//                 );

//                 if (filteredBillers.length > 0) {
//                     setBillers(filteredBillers);
//                 } else {
//                     setBillerError("No billers available for selected provider.");
//                 }

//             } else {
//                 setBillerError("No billers available at the moment.");
//             }


//         } catch (err) {
//             console.error("Biller API Error:", err);
//             setBillerError(
//                 "Network error while fetching billers. Please try again."
//             );
//         } finally {
//             setLoadingBillers(false);
//         }
//     };


//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (name === "billerId") {
//             // const selectedBiller = billers.find(biller => biller.billerId.toString() === value);
//             // const selectedBiller = billers.find(
//             //     (biller) => biller.billerId != null && String(biller.billerId) === String(value)
//             // );
//             const selectedBiller = billers.find(
//                 (biller) => String(getBillerId(biller)) === String(value)
//             );
//             setSelectedBillerExactness(selectedBiller?.paymentAmountExactness || null);
//         }
//         //         if (name === "billerId") {
//         //     const selectedBiller = billers.find(
//         //         (biller) => String(biller.serviceId) === String(value)
//         //     );
//         //     setSelectedBillerExactness(selectedBiller?.paymentAmountExactness || null);
//         // }

//         setFormData((prev) => ({
//             ...prev,
//             [name]: value,
//         }));

//         if (error) setError("");
//         if (success) setSuccess(false);
//         if (billFetched && name !== "amount") {
//             setBillFetched(false);
//             setBillDetails(null);
//         }
//     };

//     const validateForm = () => {
//         const { billerId, cardNumber, confirmCardNumber, mobileNumber } = formData;

//         if (!billerId) {
//             setError("Please select a biller.");
//             return false;
//         }

//         if (!cardNumber || !confirmCardNumber || !mobileNumber) {
//             setError("Please fill all required fields.");
//             return false;
//         }

//         if (cardNumber !== confirmCardNumber) {
//             setError("Credit card numbers do not match.");
//             return false;
//         }

//         if (!/^\d{4}$/.test(cardNumber)) {
//             setError("Card number should be exactly 4 digits.");
//             return false;
//         }

//         if (!/^\d{10}$/.test(mobileNumber)) {
//             setError("Mobile number should be exactly 10 digits.");
//             return false;
//         }

//         if (!account_no) {
//             setError("Merchant account number is not available. Please login again.");
//             return false;
//         }

//         return true;
//     };

//     const validatePayment = () => {
//         if (!billDetails) {
//             setError("Bill details are not available. Please fetch the bill first.");
//             return false;
//         }

//         if (!formData.amount || formData.amount.trim() === "") {
//             setError("Please enter a payment amount.");
//             return false;
//         }

//         const enteredAmount = parseFloat(formData.amount);
//         const billNetAmount = billDetails.billNetAmount || 0;

//         if (isNaN(enteredAmount) || enteredAmount <= 0) {
//             setError("Please enter a valid payment amount greater than zero.");
//             return false;
//         }

//         // const selectedBiller = billers.find(biller => biller.billerId.toString() === formData.billerId);
//         const selectedBiller = billers.find(
//             (biller) => String(getBillerId(biller)) === String(formData.billerId)
//         );
//         // const selectedBiller = billers.find(biller => String(biller.serviceId) === String(formData.billerId));
//         const exactness = selectedBiller?.paymentAmountExactness;

//         if (exactness === "EXACT" && enteredAmount !== billNetAmount) {
//             setError(`This biller requires the exact bill amount: ₹${billNetAmount.toFixed(2)}`);
//             return false;
//         } else if (exactness === "EXACT_AND_BELOW" && enteredAmount > billNetAmount) {
//             setError(`Amount cannot exceed the bill amount of ₹${billNetAmount.toFixed(2)}`);
//             return false;
//         } else if (exactness === "EXACT_AND_ABOVE" && enteredAmount < billNetAmount) {
//             setError(`Amount cannot be less than the bill amount of ₹${billNetAmount.toFixed(2)}`);
//             return false;
//         }

//         if (!account_no) {
//             setError("Merchant account number is not available. Please login again.");
//             return false;
//         }

//         return true;
//     };


//     const buildBillParams = (biller) => {
//         let params = { lat, long: lng };

//         biller.inputParams?.forEach((param) => {
//             const key = param.paramKey;
//             const name = param.paramName?.toLowerCase() || "";

//             if (name.includes("mobile")) {
//                 params[key] = formData.mobileNumber;
//             }
//             else if (name.includes("card")) {
//                 params[key] = formData.cardNumber;
//             }
//         });

//         return params;
//     };

//     const handleFetchBill = async (e) => {
//         e.preventDefault();

//         if (!validateForm()) return;

//         setLoading(true);
//         setError("");
//         setBillFetched(false);
//         setBillDetails(null);

//         try {
//             const selectedBiller = billers.find(
//                 (biller) => String(getBillerId(biller)) === String(formData.billerId)
//             );

//             if (!selectedBiller) {
//                 throw new Error("Selected biller information not found");
//             }

//             /* ---------- BUILD BILL PARAMS DYNAMICALLY ---------- */

//             // let billParams = { lat, long: lng };

//             // selectedBiller.inputParams?.forEach((param) => {
//             //     const key = param.paramKey;
//             //     const name = param.paramName?.toLowerCase() || "";

//             //     if (name.includes("mobile")) {
//             //         billParams[key] = formData.mobileNumber;
//             //     }
//             //     else if (name.includes("card")) {
//             //         billParams[key] = formData.cardNumber;
//             //     }
//             // });
//             const billParams = buildBillParams(selectedBiller);

//             /* ---------- FETCH BILL ---------- */

//             const fetchBillRequestData = {
//                 billerId: formData.billerId,
//                 serviceCode: selectedBiller.serviceCode,
//                 billParams: billParams,
//             };

//             const response = await creditcardfetchbill(
//                 fetchBillRequestData,
//                 `?username=${username}`
//             );

//             console.log("API Response:", response);

//             if (response.responseCode === 0) {
//                 setBillDetails(response);
//                 setBillFetched(true);

//                 if (selectedBiller.paymentAmountExactness === "EXACT") {
//                     setFormData((prev) => ({
//                         ...prev,
//                         amount: response.billNetAmount.toString(),
//                     }));
//                 } else {
//                     setFormData((prev) => ({
//                         ...prev,
//                         amount: "",
//                     }));
//                 }
//             }
//             else if (response.error_code === 202) {
//                 setError(response.message);
//             }
//             else {
//                 setError("Could not retrieve bill details. Please try again.");
//             }
//         } catch (err) {
//             console.error("API Error:", err);

//             if (err.response) {
//                 setError(
//                     `Server error: ${err.response.status} - ${err.response?.response_message || "Unknown error"
//                     }`
//                 );
//             }
//             else if (err.request) {
//                 setError(
//                     "Network error: No response received from server. Please check your connection."
//                 );
//             }
//             else {
//                 setError(`Error: ${err.message || "An unknown error occurred"}`);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     const calculateFee = async (amount) => {
//         try {
//             const requestData = {
//                 provider: "CCBP",
//                 sub_provider: "ENKASH",
//                 amount: parseFloat(amount),
//                 commercial_type: "TRANSACTION_FEE",
//                 mid: username
//             };
//             const response = await calculatefee(requestData)

//             console.log("Fee API Response Status:", response);
//             console.log("Fee API Response Data:", response);

//             if (response) {
//                 return response;
//             } else {
//                 throw new Error(response.response_message || "Failed to calculate fee");
//             }
//         } catch (err) {
//             console.error("Fee Calculation API Error:", err);
//             throw new Error("Could not calculate transaction fee. Please try again.");
//         }
//     };

//     const handlePayBill = async (e) => {
//         e.preventDefault();

//         if (!validatePayment()) {
//             return;
//         }

//         try {
//             setLoading(true);
//             setError("");

//             const feeResponse = await calculateFee(formData.amount);
//             setFeeDetails(feeResponse);

//             setShowFeeConfirmation(true);

//         } catch (err) {
//             console.error("Fee calculation failed:", err);
//             setError(err.message || "Failed to calculate transaction fee");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const normalizeTxnStatus = (response, data) => {
//         const rawStatus =
//             data?.status ||
//             data?.txnStatus ||
//             data?.response_status ||
//             data?.response_message ||
//             response?.status;

//         return rawStatus || "PENDING"; // default
//     };
//     const proceedWithPayment = async () => {
//         setShowFeeConfirmation(false);
//         setLoading(true);
//         setError("");
//         setMpin("");

//         try {
//             // const selectedBiller = billers.find(
//             //     biller => biller.billerId.toString() === formData.billerId
//             // );
//             const selectedBiller = billers.find(
//                 (biller) => String(getBillerId(biller)) === String(formData.billerId)
//             );

//             if (!selectedBiller) {
//                 throw new Error("Selected biller information not found");
//             }

//             // const addBillRequestData = {
//             //     billerId: formData.billerId,
//             //     serviceCode: selectedBiller.serviceCode,
//             //     billParams: {
//             //         cn: formData.mobileNumber,
//             //         ad1: formData.cardNumber
//             //     },
//             //     net_amount: feeDetails.net_amount,
//             //     txn_amount: feeDetails.txn_amount,
//             //     merchant_account_no: account_no,
//             //     biller_name: selectedBiller.name
//             // };
//             const addBillRequestData = {
//                 billerId: formData.billerId,
//                 serviceCode: selectedBiller.serviceCode,
//                 // billParams: {
//                 //     cn: formData.mobileNumber,
//                 //     ad1: formData.cardNumber,
//                 //     lat,
//                 //     long: lng,
//                 // },
//                 billParams: buildBillParams(selectedBiller),
//                 net_amount: feeDetails.net_amount,
//                 txn_amount: feeDetails.txn_amount,
//                 merchant_account_no: account_no,
//                 biller_name: selectedBiller.name,
//                 mid: username,
//                 mpin,
//                 billData: {
//                     customerName: billDetails?.billData?.customerName,
//                     billId: billDetails?.billData?.billId,
//                     billDate: billDetails?.billData?.billDate,
//                     dueDate: billDetails?.billData?.dueDate,
//                     billPeriod: billDetails?.billData?.billPeriod,
//                     amount: billDetails?.billData?.amount,
//                     requestId: billDetails?.billData?.requestId,
//                     searchID: billDetails?.billData?.searchID,
//                 },
//             };

//             const response = await creditcardaddbill(addBillRequestData, `?username=${username}`);
//             const data = response?.data || response;

//             // RAW STATUS FROM PROVIDER
//             const providerStatus = normalizeTxnStatus(response, data);

//             setPaymentResponse({
//                 status: providerStatus,
//                 message:
//                     data?.message ||
//                     data?.response_message ||
//                     providerStatus // fallback
//             });

//             setResponseStatus(providerStatus);

//             // Refresh wallet only if NOT failed
//             if (providerStatus !== "FAILED" && providerStatus !== "WALLET_DEBIT_FAILED") {
//                 dispatch(fetchWalletBalance());
//                 dispatch(fetchAepsBalance());
//                 dispatch(fetchSettlementBalance());
//             }

//             // Reset form
//             setFormData({
//                 billerId: "",
//                 cardNumber: "",
//                 confirmCardNumber: "",
//                 mobileNumber: "",
//                 amount: "",
//             });

//             setBillDetails(null);
//             setBillFetched(false);

//         } catch (err) {
//             console.error("API Error:", err);

//             setPaymentResponse({
//                 status: "FAILED",
//                 message:
//                     err.response?.data?.message ||
//                     err.response?.data?.response_message ||
//                     err.message ||
//                     "Server error"
//             });

//             setResponseStatus("FAILED");
//         } finally {
//             setLoading(false);
//             dispatch(fetchWalletBalance());
//             dispatch(fetchAepsBalance());
//             dispatch(fetchSettlementBalance());
//         }
//     };


//     const closePaymentPopup = () => {
//         setPaymentResponse(null);
//     };

//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";

//         try {
//             const date = new Date(dateString);
//             return date.toLocaleDateString('en-IN', {
//                 day: '2-digit',
//                 month: '2-digit',
//                 year: 'numeric'
//             });
//         } catch (error) {
//             console.error("Error formatting date:", error);
//             return dateString;
//         }
//     };

//     const getPaymentInstructionText = () => {
//         // const selectedBiller = billers.find(biller => biller.billerId.toString() === formData.billerId);
//         const selectedBiller = billers.find(
//             (biller) => String(getBillerId(biller)) === String(formData.billerId)
//         );
//         // const selectedBiller = billers.find(biller => String(biller.serviceId) === String(formData.billerId));
//         const exactness = selectedBiller?.paymentAmountExactness;
//         const billAmount = billDetails?.billAmount || 0;

//         if (exactness === "EXACT") {
//             return "This biller requires payment of the exact bill amount.";
//         } else if (exactness === "EXACT_AND_BELOW") {
//             return `You can pay any amount up to ₹${billAmount.toFixed(2)}.`;
//         } else if (exactness === "EXACT_AND_ABOVE") {
//             return `You must pay at least ₹${billAmount.toFixed(2)}.`;
//         } else {
//             return billDetails?.acceptPartPay
//                 ? "You can enter any amount for this bill."
//                 : "Please enter the amount you wish to pay.";
//         }
//     };

//     return (
//         <div className="min-h-screen bg-[#EEF2F8] flex items-center justify-center px-6">
//             <div
//                 className="
//         w-full max-w-4xl
//         bg-[#F7FAFF]
//         rounded-[28px]
//         p-10
//         shadow-[0_50px_100px_rgba(31,42,68,0.22)]
//         border border-white/60
//       "
//             >
//                 <h2 className="text-3xl font-semibold text-[#1F2A44] text-center">
//                     Credit Card Bill Payment
//                 </h2>

//                 <p className="text-sm text-[#1F2A44]/60 text-center mt-2 mb-8">
//                     Fast • Secure • Trusted Payments
//                 </p>

//                 {/* INFO */}
//                 <div
//                     className="
//           mb-8 rounded-xl px-6 py-4 text-sm text-center
//           bg-[#EEF2F8]
//           shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]
//           text-[#1F2A44]/70
//         "
//                 >
//                     Zap your credit card bill away in seconds 🚀
//                 </div>

//                 {/* ================= FETCH BILL ================= */}
//                 {!billFetched ? (
//                     <form onSubmit={handleFetchBill} autoComplete="off" className="space-y-6">
//                         <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//                         <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />
//                         {/* BILLER */}
//                         {/* <div>
//                             <label className="text-xs font-medium text-[#1F2A44]/70">
//                                 Select Credit Card Bank *
//                             </label>
//                             <select
//                                 name="billerId"
//                                 value={formData.billerId}
//                                 onChange={handleChange}
//                                 disabled={loadingBillers}
//                                 className="
//                 mt-2 w-full px-4 py-3 rounded-xl
//                 bg-[#EEF2F8]
//                 shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]
//                 outline-none
//               "
//                             >
//                                 <option value="">Select a biller</option>
//                                 {billers.map((b) => (
//                                     <option key={b.billerId} value={b.billerId}>
//                                         {b.bankName}
//                                     </option>
//                                 ))}
//                             </select>
//                             {loadingBillers && (
//                                 <p className="text-xs text-[#3FB6B2] mt-1">Loading billers…</p>
//                             )}
//                             {billerError && (
//                                 <p className="text-xs text-[#E23A2E] mt-1">{billerError}</p>
//                             )}
//                         </div> */}
//                         <div>
//                             <label className="text-xs font-medium text-[#1F2A44]/70">
//                                 Select Credit Card Bank *
//                             </label>
//                             {/* <div className="relative mt-2"> */}
//                             <div className="biller-dropdown-wrapper relative mt-2">
//                                 {/* Search Input */}
//                                 <div
//                                     className="
//                 w-full px-4 py-3 rounded-xl flex items-center justify-between cursor-pointer
//                 bg-[#EEF2F8]
//                 shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]
//             "
//                                     onClick={() => !loadingBillers && setBillerDropdownOpen((p) => !p)}
//                                 >
//                                     {/* <span className={formData.billerId ? "text-[#1F2A44]" : "text-[#1F2A44]/40"}>
//                                         {formData.billerId
//                                             ? billers.find((b) => String(b.billerId) === String(formData.billerId))?.bankName
//                                             : loadingBillers ? "Loading billers…" : "Select a biller"}
//                                     </span> */}
//                                     <span className={selectedBillerName ? "text-[#1F2A44]" : "text-[#1F2A44]/40"}>
//                                         {selectedBillerName ?? (loadingBillers ? "Loading billers…" : "Select a biller")}
//                                     </span>
//                                     <svg
//                                         className={`w-4 h-4 text-[#1F2A44]/50 transition-transform ${billerDropdownOpen ? "rotate-180" : ""}`}
//                                         fill="none" stroke="currentColor" strokeWidth="2"
//                                         viewBox="0 0 24 24"
//                                     >
//                                         <polyline points="6 9 12 15 18 9" />
//                                     </svg>
//                                 </div>

//                                 {/* Dropdown Panel */}
//                                 {billerDropdownOpen && (
//                                     <div className="absolute z-50 mt-2 w-full rounded-xl bg-[#F7FAFF] shadow-[0_8px_30px_rgba(31,42,68,0.15)] border border-white/60 overflow-hidden">
//                                         {/* Search Box */}
//                                         <div className="p-2 border-b border-[#EEF2F8]">
//                                             <input
//                                                 autoFocus
//                                                 type="text"
//                                                 value={billerSearch}
//                                                 onChange={(e) => setBillerSearch(e.target.value)}
//                                                 placeholder="Search bank..."
//                                                 className="
//                             w-full px-3 py-2 rounded-lg text-sm outline-none
//                             bg-[#EEF2F8]
//                             shadow-[inset_3px_3px_6px_#cdd3df,inset_-3px_-3px_6px_#ffffff]
//                             text-[#1F2A44] placeholder:text-[#1F2A44]/40
//                         "
//                                             />
//                                         </div>

//                                         {/* Options List */}
//                                         <ul className="max-h-52 overflow-y-auto">
//                                             {billers
//                                                 .filter((b) =>
//                                                     b.bankName.toLowerCase().includes(billerSearch.toLowerCase())
//                                                 )
//                                                 .map((b) => (
//                                                     <li
//                                                         // key={b.billerId}
//                                                         key={getBillerId(b)}
//                                                         onClick={() => {
//                                                             handleChange({
//                                                                 // target: { name: "billerId", value: String(b.billerId) },
//                                                                 target: { name: "billerId", value: String(getBillerId(b)) },
//                                                             });
//                                                             setBillerDropdownOpen(false);
//                                                             setBillerSearch("");
//                                                         }}
//                                                         className={`
//                                     px-4 py-3 text-sm cursor-pointer transition-colors
//                                     hover:bg-[#EEF2F8] text-[#1F2A44]

//                                         ${String(formData.billerId) === String(getBillerId(b))
//                                                                 ? "bg-[#EEF2F8] font-semibold text-[#E23A2E]"
//                                                                 : ""}
//                                 `}
//                                                     >
//                                                         {/* ${String(formData.billerId) === String(b.billerId) */}
//                                                         {b.bankName}
//                                                     </li>
//                                                 ))}
//                                             {billers.filter((b) =>
//                                                 b.bankName.toLowerCase().includes(billerSearch.toLowerCase())
//                                             ).length === 0 && (
//                                                     <li className="px-4 py-3 text-sm text-[#1F2A44]/40 text-center">
//                                                         No banks found
//                                                     </li>
//                                                 )}
//                                         </ul>
//                                     </div>
//                                 )}
//                             </div>

//                             {billerError && (
//                                 <p className="text-xs text-[#E23A2E] mt-1">{billerError}</p>
//                             )}
//                         </div>

//                         {/* CARD */}
//                         <div>
//                             <label className="text-xs font-medium text-[#1F2A44]/70">
//                                 Last 4 Digits of Card *
//                             </label>
//                             <input
//                                 name="cardNumber"
//                                 maxLength={4}
//                                 value={formData.cardNumber}
//                                 onChange={handleChange}
//                                 autoComplete="off"
//                                 autoCorrect="off"
//                                 autoCapitalize="off"
//                                 spellCheck="false"
//                                 className="mt-2 w-full px-4 py-3 rounded-xl bg-[#EEF2F8]
//               shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]"
//                             />
//                         </div>

//                         {/* CONFIRM */}
//                         <div>
//                             <label className="text-xs font-medium text-[#1F2A44]/70">
//                                 Confirm Card Digits *
//                             </label>
//                             <input
//                                 name="confirmCardNumber"
//                                 maxLength={4}
//                                 value={formData.confirmCardNumber}
//                                 onChange={handleChange}
//                                 className="mt-2 w-full px-4 py-3 rounded-xl bg-[#EEF2F8]
//               shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]"
//                             />
//                         </div>

//                         {/* MOBILE */}
//                         <div>
//                             <label className="text-xs font-medium text-[#1F2A44]/70">
//                                 Mobile Number *
//                             </label>
//                             <input
//                                 name="mobileNumber"
//                                 maxLength={10}
//                                 value={formData.mobileNumber}
//                                 onChange={handleChange}
//                                 autoComplete="off"
//                                 autoCorrect="off"
//                                 autoCapitalize="off"
//                                 spellCheck="false"
//                                 className="mt-2 w-full px-4 py-3 rounded-xl bg-[#EEF2F8]
//               shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]"
//                             />
//                         </div>

//                         {error && (
//                             <div className="text-sm text-[#E23A2E] bg-[#E23A2E]/10 border border-[#E23A2E]/30 rounded-lg px-3 py-2">
//                                 {error}
//                             </div>
//                         )}

//                         <button
//                             type="submit"
//                             disabled={loading}
//                             className="
//               w-full py-4 rounded-xl font-semibold text-white
//               bg-gradient-to-r from-[#E23A2E] to-[#3FB6B2]
//               shadow-[6px_6px_12px_#cdd3df,-6px_-6px_12px_#ffffff]
//               hover:shadow-[inset_4px_4px_8px_rgba(0,0,0,0.18)]
//             "
//                         >
//                             {loading ? "Fetching Bill…" : "Fetch Bill"}
//                         </button>
//                     </form>
//                 ) : (
//                     /* ================= BILL DETAILS ================= */
//                     <div className="space-y-6">
//                         <div
//                             className="
//               rounded-2xl p-6 bg-[#EEF2F8]
//               shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]
//             "
//                         >
//                             <h3 className="font-semibold text-[#1F2A44] mb-4">Bill Details</h3>

//                             <div className="grid grid-cols-2 gap-3 text-sm">
//                                 <span>Customer</span><span>{billDetails.name || "N/A"}</span>
//                                 <span>Bill Number</span><span>{billDetails.billNumber}</span>
//                                 <span>Bill Date</span><span>{formatDate(billDetails.billDate)}</span>
//                                 <span>Due Date</span>
//                                 <span className="text-[#E23A2E]">
//                                     {formatDate(billDetails.dueDate)}
//                                 </span>
//                                 <span>Bill Amount</span>
//                                 <span className="font-semibold">
//                                     ₹{billDetails.billAmount}
//                                 </span>
//                             </div>
//                         </div>

//                         <form onSubmit={handlePayBill} autoComplete="off" className="space-y-4">
//                             <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
//                             <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />
//                             <input
//                                 name="amount"
//                                 value={formData.amount}
//                                 onChange={handleChange}
//                                 readOnly={selectedBillerExactness === "EXACT"}
//                                 placeholder="Enter Amount"
//                                 className="
//                 w-full px-4 py-3 rounded-xl bg-[#EEF2F8]
//                 shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]
//               "
//                             />

//                             <p className="text-xs text-[#1F2A44]/60">
//                                 {getPaymentInstructionText()}
//                             </p>

//                             {error && <p className="text-sm text-[#E23A2E]">{error}</p>}

//                             {/* {billDetails && billDetails.acceptPayment === false && (
//                                 <div className="mb-3 text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">
//                                     ⚠ Your acceptPayment is not enabled from provider side.
//                                     This bill cannot be paid at the moment.
//                                 </div>
//                             )} */}

//                             <input
//                                 type="password"
//                                 maxLength={6}
//                                 value={mpin}
//                                 onChange={(e) => setMpin(e.target.value)}
//                                 placeholder="Enter 6-digit MPIN"
//                                 autoComplete="off"
//                                 autoCorrect="off"
//                                 autoCapitalize="off"
//                                 spellCheck="false"
//                                 className="w-full px-4 py-3 rounded-xl bg-[#EEF2F8]
//     shadow-[inset_6px_6px_12px_#cdd3df,inset_-6px_-6px_12px_#ffffff]"
//                             />

//                             <div className="flex gap-4">
//                                 <button
//                                     type="button"
//                                     onClick={() => {
//                                         setBillFetched(false);
//                                         setBillDetails(null);
//                                     }}
//                                     className="flex-1 py-3 rounded-xl bg-gray-200 hover:bg-gray-300"
//                                 >
//                                     Back
//                                 </button>

//                                 <button
//                                     type="submit"
//                                     disabled={loading}
//                                     className={`
//     flex-1 py-3 rounded-xl text-white transition-all duration-200
//     flex items-center justify-center gap-2

//     ${loading
//                                             ? "bg-gray-400 cursor-not-allowed opacity-70"
//                                             : "bg-gradient-to-r from-[#E23A2E] to-[#3FB6B2] hover:opacity-90 cursor-pointer"
//                                         }
//   `}
//                                 >
//                                     {loading ? (
//                                         <>
//                                             <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
//                                             Processing...
//                                         </>
//                                     ) : (
//                                         "Pay Bill"
//                                     )}
//                                 </button>
//                             </div>
//                         </form>
//                     </div>
//                 )}

//                 {/* ================= FEE CONFIRMATION POPUP ================= */}
//                 {showFeeConfirmation && feeDetails && (
//                     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//                         <div className="bg-[#F7FAFF] rounded-2xl p-6 w-full max-w-md shadow-xl">
//                             <h3 className="font-semibold text-[#1F2A44] mb-4">
//                                 Payment Confirmation
//                             </h3>

//                             <div className="space-y-3 text-sm">
//                                 <div className="flex justify-between">
//                                     <span>Bill Amount</span>
//                                     <span>₹{feeDetails.net_amount}</span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                     <span>Transaction Fee</span>
//                                     <span>₹{feeDetails.fee}</span>
//                                 </div>
//                                 <div className="flex justify-between font-semibold text-[#E23A2E]">
//                                     <span>Total Amount</span>
//                                     <span>₹{feeDetails.txn_amount}</span>
//                                 </div>
//                             </div>

//                             <div className="flex gap-4 mt-6">
//                                 <button
//                                     onClick={() => setShowFeeConfirmation(false)}
//                                     className="flex-1 py-3 rounded-xl bg-gray-200"
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     onClick={proceedWithPayment}
//                                     className="flex-1 py-3 rounded-xl text-white bg-gradient-to-r from-[#E23A2E] to-[#3FB6B2]"
//                                 >
//                                     Confirm & Pay
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                 )}

//                 {/* ================= PAYMENT RESULT POPUP ================= */}
//                 {paymentResponse && (
//                     <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
//                         <div className="bg-[#F7FAFF] rounded-2xl p-6 w-full max-w-md shadow-xl">
//                             {/* <h3 className="font-semibold text-[#1F2A44] mb-4">
//                                 {responseStatus === "success"
//                                     ? "Payment Successful"
//                                     : responseStatus === "pending"
//                                         ? "Payment Pending"
//                                         : "Payment Failed"}
//                             </h3> */}

//                             {responseStatus === "success" ? (
//                                 <div className="text-sm space-y-2">
//                                     <p>Transaction ID: {paymentResponse.txnId}</p>
//                                     <p>Status: {paymentResponse.status}</p>
//                                 </div>
//                             ) : (
//                                 <p className="text-sm text-[#E23A2E]">
//                                     {paymentResponse.message}
//                                 </p>
//                             )}

//                             <button
//                                 onClick={closePaymentPopup}
//                                 className="w-full mt-6 py-3 rounded-xl text-white bg-gradient-to-r from-[#E23A2E] to-[#3FB6B2]"
//                             >
//                                 Close
//                             </button>
//                         </div>
//                     </div>
//                 )}
//             </div>
//         </div>
//     );


// };

// export default Ccbp;

import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    fetchAepsBalance,
    fetchSettlementBalance,
    fetchWalletBalance,
} from "../../../Store/Slices/WalletSlice";
import useApi from "../../../CustomHooks/useApi";
import {
    CreditCard,
    User,
    Phone,
    ChevronDown,
    Search,
    IndianRupee,
    Lock,
    ShieldCheck,
    Loader2,
    CheckCircle2,
    XCircle,
    Clock3,
    ArrowLeft,
    Receipt,
} from "lucide-react";

const Ccbp = () => {
    const [formData, setFormData] = useState({
        billerId: "",
        cardNumber: "",
        confirmCardNumber: "",
        mobileNumber: "",
        amount: "",
    });

    const getBillerId = (b) => b.billerId || b.serviceId;

    const [error, setError] = useState("");
    const [amountError, setAmountError] = useState("");
    const [loading, setLoading] = useState(false);
    const [billers, setBillers] = useState([]);
    const [loadingBillers, setLoadingBillers] = useState(false);
    const [billerError, setBillerError] = useState("");
    const { lat, lng } = useSelector((state) => state.location);
    const [billerDropdownOpen, setBillerDropdownOpen] = useState(false);
    const [billerSearch, setBillerSearch] = useState("");

    const selectedBillerName = billers.find(
        (b) => String(getBillerId(b)) === String(formData.billerId)
    )?.bankName;

    const [billDetails, setBillDetails] = useState(null);
    const [billFetched, setBillFetched] = useState(false);
    const [mpin, setMpin] = useState("");
    const [paymentResponse, setPaymentResponse] = useState(null);
    const [responseStatus, setResponseStatus] = useState(null);
    const [selectedBillerExactness, setSelectedBillerExactness] = useState(null);
    const [feeDetails, setFeeDetails] = useState(null);
    const [showFeeConfirmation, setShowFeeConfirmation] = useState(false);

    const token = useSelector((state) => state.auth.employeeDetails?.token);
    const account_no = useSelector((state) => state.auth.employeeDetails?.merchant_account_no);
    const username = useSelector((state) => state.auth.employeeDetails?.username);
    const dispatch = useDispatch();

    const { callApi: fetchcard } = useApi("/creditCard/biller");
    const { callApi: creditcardaddbill } = useApi("/creditCard/add-bill", "POST");
    const { callApi: creditcardfetchbill } = useApi("/creditCard/fetch-bill", "POST");
    const { callApi: calculatefee } = useApi("/dmt/fee/calculate", "POST");

    useEffect(() => {
        fetchBillers();
    }, [token]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (!e.target.closest(".biller-dropdown-wrapper")) {
                setBillerDropdownOpen(false);
                setBillerSearch("");
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const fetchBillers = async () => {
        setLoadingBillers(true);
        setBillerError("");
        setBillers([]);
        try {
            const response = await fetchcard();
            if (response?.error_code === 202 || response?.error === "Accepted") {
                setBillerError(response.message || "Failed to load billers.");
                return;
            }
            if (Array.isArray(response) && response.length > 0) {
                const filteredBillers = response.filter(
                    (b) => b.bankName && ["EZYPAY", "ENKASH", "BOTH"].includes(b.provider)
                );
                if (filteredBillers.length > 0) {
                    setBillers(filteredBillers);
                } else {
                    setBillerError("No billers available for selected provider.");
                }
            } else {
                setBillerError("No billers available at the moment.");
            }
        } catch (err) {
            setBillerError("Network error while fetching billers. Please try again.");
        } finally {
            setLoadingBillers(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "amount") {
            // Reject non-numeric characters (allow digits and a single decimal point only)
            if (value !== "" && !/^\d*\.?\d*$/.test(value)) return;
            // Reject negative
            if (value.startsWith("-")) return;

            const numVal = parseFloat(value);
            if (!isNaN(numVal) && numVal > 49999) {
                setAmountError("Maximum amount allowed is ₹49,999.");
                setFormData((prev) => ({ ...prev, amount: "49999" }));
                return;
            }
            setAmountError("");
        }

        if (name === "billerId") {
            const selectedBiller = billers.find(
                (biller) => String(getBillerId(biller)) === String(value)
            );
            setSelectedBillerExactness(selectedBiller?.paymentAmountExactness || null);
        }
        setFormData((prev) => ({ ...prev, [name]: value }));
        if (error) setError("");
        if (billFetched && name !== "amount") {
            setBillFetched(false);
            setBillDetails(null);
        }
    };

    const validateForm = () => {
        const { billerId, cardNumber, confirmCardNumber, mobileNumber } = formData;
        if (!billerId) { setError("Please select a biller."); return false; }
        if (!cardNumber || !confirmCardNumber || !mobileNumber) { setError("Please fill all required fields."); return false; }
        if (cardNumber !== confirmCardNumber) { setError("Credit card numbers do not match."); return false; }
        if (!/^\d{4}$/.test(cardNumber)) { setError("Card number should be exactly 4 digits."); return false; }
        if (!/^\d{10}$/.test(mobileNumber)) { setError("Mobile number should be exactly 10 digits."); return false; }
        if (!account_no) { setError("Merchant account number is not available. Please login again."); return false; }
        return true;
    };

    const validatePayment = () => {
        if (!billDetails) { setError("Bill details are not available. Please fetch the bill first."); return false; }
        if (!formData.amount || formData.amount.trim() === "") { setError("Please enter a payment amount."); return false; }
        const enteredAmount = parseFloat(formData.amount);
        const billNetAmount = billDetails.billNetAmount || 0;
        if (isNaN(enteredAmount) || enteredAmount <= 0) { setError("Please enter a valid payment amount greater than zero."); return false; }
        if (enteredAmount > 49999) { setError("Maximum amount allowed is ₹49,999."); return false; }
        const selectedBiller = billers.find((biller) => String(getBillerId(biller)) === String(formData.billerId));
        const exactness = selectedBiller?.paymentAmountExactness;
        if (exactness === "EXACT" && enteredAmount !== billNetAmount) { setError(`This biller requires the exact bill amount: ₹${billNetAmount.toFixed(2)}`); return false; }
        else if (exactness === "EXACT_AND_BELOW" && enteredAmount > billNetAmount) { setError(`Amount cannot exceed the bill amount of ₹${billNetAmount.toFixed(2)}`); return false; }
        else if (exactness === "EXACT_AND_ABOVE" && enteredAmount < billNetAmount) { setError(`Amount cannot be less than the bill amount of ₹${billNetAmount.toFixed(2)}`); return false; }
        if (!account_no) { setError("Merchant account number is not available. Please login again."); return false; }
        return true;
    };

    const buildBillParams = (biller) => {
        let params = { lat, long: lng };
        biller.inputParams?.forEach((param) => {
            const key = param.paramKey;
            const name = param.paramName?.toLowerCase() || "";
            if (name.includes("mobile")) params[key] = formData.mobileNumber;
            else if (name.includes("card")) params[key] = formData.cardNumber;
        });
        return params;
    };

    const handleFetchBill = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setLoading(true);
        setError("");
        setBillFetched(false);
        setBillDetails(null);
        try {
            const selectedBiller = billers.find(
                (biller) => String(getBillerId(biller)) === String(formData.billerId)
            );
            if (!selectedBiller) throw new Error("Selected biller information not found");
            const billParams = buildBillParams(selectedBiller);
            const response = await creditcardfetchbill(
                { billerId: formData.billerId, serviceCode: selectedBiller.serviceCode, billParams },
                `?username=${username}`
            );
            if (response.responseCode === 0) {
                setBillDetails(response);
                setBillFetched(true);
                setFormData((prev) => ({
                    ...prev,
                    amount: selectedBiller.paymentAmountExactness === "EXACT"
                        ? response.billNetAmount.toString()
                        : "",
                }));
            } else if (response.error_code === 202) {
                setError(response.message);
            } else {
                setError("Could not retrieve bill details. Please try again.");
            }
        } catch (err) {
            setError(err.message || "An unknown error occurred");
        } finally {
            setLoading(false);
        }
    };

    const calculateFee = async (amount) => {
        try {
            const response = await calculatefee({
                provider: "CCBP",
                sub_provider: "ENKASH",
                amount: parseFloat(amount),
                commercial_type: "TRANSACTION_FEE",
                mid: username,
            });
            if (response) return response;
            throw new Error("Failed to calculate fee");
        } catch (err) {
            throw new Error("Could not calculate transaction fee. Please try again.");
        }
    };

    const handlePayBill = async (e) => {
        e.preventDefault();
        if (!validatePayment()) return;
        try {
            setLoading(true);
            setError("");
            const feeResponse = await calculateFee(formData.amount);
            setFeeDetails(feeResponse);
            setShowFeeConfirmation(true);
        } catch (err) {
            setError(err.message || "Failed to calculate transaction fee");
        } finally {
            setLoading(false);
        }
    };

    const normalizeTxnStatus = (response, data) => {
        const rawStatus =
            data?.status || data?.txnStatus || data?.response_status ||
            data?.response_message || response?.status;
        return rawStatus || "PENDING";
    };

    const proceedWithPayment = async () => {
        setShowFeeConfirmation(false);
        setLoading(true);
        setError("");
        setMpin("");
        try {
            const selectedBiller = billers.find(
                (biller) => String(getBillerId(biller)) === String(formData.billerId)
            );
            if (!selectedBiller) throw new Error("Selected biller information not found");
            const addBillRequestData = {
                billerId: formData.billerId,
                serviceCode: selectedBiller.serviceCode,
                billParams: buildBillParams(selectedBiller),
                net_amount: feeDetails.net_amount,
                txn_amount: feeDetails.txn_amount,
                merchant_account_no: account_no,
                biller_name: selectedBiller.name,
                mid: username,
                mpin,
                billData: {
                    customerName: billDetails?.billData?.customerName,
                    billId: billDetails?.billData?.billId,
                    billDate: billDetails?.billData?.billDate,
                    dueDate: billDetails?.billData?.dueDate,
                    billPeriod: billDetails?.billData?.billPeriod,
                    amount: billDetails?.billData?.amount,
                    requestId: billDetails?.billData?.requestId,
                    searchID: billDetails?.billData?.searchID,
                },
            };
            const response = await creditcardaddbill(addBillRequestData, `?username=${username}`);
            const data = response?.data || response;
            const providerStatus = normalizeTxnStatus(response, data);
            setPaymentResponse({
                status: providerStatus,
                message: data?.message || data?.response_message || providerStatus,
            });
            setResponseStatus(providerStatus);
            if (providerStatus !== "FAILED" && providerStatus !== "WALLET_DEBIT_FAILED") {
                dispatch(fetchWalletBalance());
                dispatch(fetchAepsBalance());
                dispatch(fetchSettlementBalance());
            }
            setFormData({ billerId: "", cardNumber: "", confirmCardNumber: "", mobileNumber: "", amount: "" });
            setBillDetails(null);
            setBillFetched(false);
        } catch (err) {
            setPaymentResponse({
                status: "FAILED",
                message: err.response?.data?.message || err.response?.data?.response_message || err.message || "Server error",
            });
            setResponseStatus("FAILED");
        } finally {
            setLoading(false);
            dispatch(fetchWalletBalance());
            dispatch(fetchAepsBalance());
            dispatch(fetchSettlementBalance());
        }
    };

    const closePaymentPopup = () => setPaymentResponse(null);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        try {
            return new Date(dateString).toLocaleDateString("en-IN", {
                day: "2-digit", month: "2-digit", year: "numeric",
            });
        } catch {
            return dateString;
        }
    };

    const getPaymentInstructionText = () => {
        const selectedBiller = billers.find(
            (biller) => String(getBillerId(biller)) === String(formData.billerId)
        );
        const exactness = selectedBiller?.paymentAmountExactness;
        const billAmount = billDetails?.billAmount || 0;
        if (exactness === "EXACT") return "This biller requires payment of the exact bill amount.";
        if (exactness === "EXACT_AND_BELOW") return `You can pay any amount up to ₹${billAmount.toFixed(2)}.`;
        if (exactness === "EXACT_AND_ABOVE") return `You must pay at least ₹${billAmount.toFixed(2)}.`;
        return billDetails?.acceptPartPay
            ? "You can enter any amount for this bill."
            : "Please enter the amount you wish to pay.";
    };


    return (
        <div className="p-4">
            <div className="bg-white rounded-3xl p-5">

                {/* ── FETCH BILL FORM ───────────────────────────────────────── */}
                {!billFetched ? (
                    <form onSubmit={handleFetchBill} autoComplete="off">
                        {/* honeypots */}
                        <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
                        <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

                        {/* ROW 1 — Biller (full width) */}
                        <div className="mb-4">
                            <label className="text-slate-800 font-semibold block mb-2">
                                Select Credit Card Bank
                            </label>
                            <div className="biller-dropdown-wrapper relative">
                                <div
                                    onClick={() => !loadingBillers && setBillerDropdownOpen((p) => !p)}
                                    className="h-14 border border-slate-200 bg-slate-50 rounded-2xl px-4 flex items-center justify-between cursor-pointer"
                                >
                                    <div className="flex items-center gap-3">
                                        <CreditCard size={20} color="#64748B" />
                                        <span className={selectedBillerName ? "text-slate-900" : "text-slate-400"}>
                                            {selectedBillerName ?? (loadingBillers ? "Loading billers…" : "Select a biller")}
                                        </span>
                                    </div>
                                    <ChevronDown
                                        size={18}
                                        color="#64748B"
                                        className={`transition-transform duration-200 ${billerDropdownOpen ? "rotate-180" : ""}`}
                                    />
                                </div>

                                {billerDropdownOpen && (
                                    <div className="absolute z-50 mt-2 w-full rounded-2xl bg-white border border-slate-200 shadow-lg overflow-hidden">
                                        <div className="p-3 border-b border-slate-100">
                                            <div className="h-10 border border-slate-200 bg-slate-50 rounded-xl px-3 flex items-center gap-2">
                                                <Search size={16} color="#94A3B8" />
                                                <input
                                                    autoFocus
                                                    type="text"
                                                    value={billerSearch}
                                                    onChange={(e) => setBillerSearch(e.target.value)}
                                                    placeholder="Search bank..."
                                                    className="flex-1 bg-transparent outline-none text-sm text-slate-900 placeholder:text-slate-400"
                                                />
                                            </div>
                                        </div>
                                        <ul className="max-h-52 overflow-y-auto">
                                            {billers
                                                .filter((b) =>
                                                    b.bankName.toLowerCase().includes(billerSearch.toLowerCase())
                                                )
                                                .map((b) => (
                                                    <li
                                                        key={getBillerId(b)}
                                                        onClick={() => {
                                                            handleChange({ target: { name: "billerId", value: String(getBillerId(b)) } });
                                                            setBillerDropdownOpen(false);
                                                            setBillerSearch("");
                                                        }}
                                                        className={`px-4 py-3 text-sm cursor-pointer transition-colors hover:bg-slate-50 text-slate-800
                                                            ${String(formData.billerId) === String(getBillerId(b))
                                                                ? "bg-blue-50 font-semibold text-blue-600"
                                                                : ""}`}
                                                    >
                                                        {b.bankName}
                                                    </li>
                                                ))}
                                            {billers.filter((b) =>
                                                b.bankName.toLowerCase().includes(billerSearch.toLowerCase())
                                            ).length === 0 && (
                                                    <li className="px-4 py-3 text-sm text-slate-400 text-center">
                                                        No banks found
                                                    </li>
                                                )}
                                        </ul>
                                    </div>
                                )}
                            </div>
                            {billerError && (
                                <p className="text-xs text-red-500 mt-1">{billerError}</p>
                            )}
                        </div>

                        {/* ROW 2 — Card + Confirm Card */}
                        <div className="grid grid-cols-2 gap-4 mb-4">
                            <InputField label="Last 4 Digits of Card" icon={CreditCard}>
                                <input
                                    name="cardNumber"
                                    maxLength={4}
                                    value={formData.cardNumber}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    placeholder="XXXX"
                                    className="flex-1 ml-3 bg-transparent outline-none text-slate-900"
                                />
                            </InputField>

                            <InputField label="Confirm Card Digits" icon={CreditCard}>
                                <input
                                    name="confirmCardNumber"
                                    maxLength={4}
                                    value={formData.confirmCardNumber}
                                    onChange={handleChange}
                                    placeholder="XXXX"
                                    className="flex-1 ml-3 bg-transparent outline-none text-slate-900"
                                />
                            </InputField>
                        </div>

                        {/* ROW 3 — Mobile (full width) */}
                        <div className="mb-4">
                            <InputField label="Mobile Number" icon={Phone}>
                                <input
                                    name="mobileNumber"
                                    maxLength={10}
                                    value={formData.mobileNumber}
                                    onChange={handleChange}
                                    autoComplete="off"
                                    placeholder="Enter 10-digit mobile number"
                                    className="flex-1 ml-3 bg-transparent outline-none text-slate-900"
                                />
                            </InputField>
                        </div>

                        {error && (
                            <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-2xl px-4 py-3 mb-4">
                                {error}
                            </div>
                        )}

                        <button
                            type="submit"
                            disabled={loading}
                            className={`h-14 w-full rounded-2xl flex items-center justify-center gap-2 transition-all duration-200 ${loading ? "bg-[#12345A] text-white" : "bg-[#12345A] text-white"
                                }`}
                        >
                            {loading ? (
                                <Loader2 size={20} color="#fff" className="animate-spin" />
                            ) : (
                                <Receipt size={20} color="#fff" />
                            )}
                            <span className="text-white text-base font-bold">
                                {loading ? "Fetching Bill…" : "Fetch Bill"}
                            </span>
                        </button>
                    </form>

                ) : (
                    /* ── BILL DETAILS + PAY FORM ───────────────────────────── */
                    <div>
                        {/* Bill Details Card */}
                        <div className="bg-blue-50 border border-blue-100 rounded-2xl p-4 mb-4">
                            <h3 className="font-semibold text-slate-800 mb-3 flex items-center gap-2">
                                <Receipt size={18} color="#2563EB" />
                                Bill Details
                            </h3>
                            <div className="space-y-2">
                                {[
                                    ["Customer", billDetails?.name || "N/A"],
                                    ["Bill Number", billDetails?.billNumber],
                                    ["Bill Date", formatDate(billDetails?.billDate)],
                                    ["Due Date", formatDate(billDetails?.dueDate)],
                                    ["Bill Amount", `₹${billDetails?.billAmount}`],
                                ].map(([label, value], i) => (
                                    <div key={i} className="flex justify-between text-sm">
                                        <span className="text-slate-500">{label}</span>
                                        <span className={`font-semibold ${label === "Due Date" ? "text-red-500" : "text-slate-800"}`}>
                                            {value}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <form onSubmit={handlePayBill} autoComplete="off">
                            <input type="text" name="fake-user" autoComplete="username" style={{ display: "none" }} />
                            <input type="password" name="fake-pass" autoComplete="current-password" style={{ display: "none" }} />

                            {/* ROW — Amount + MPIN */}
                            <div className="grid grid-cols-2 gap-4 mb-2">
                                <div>
                                    <InputField label="Amount (Max Limit: ₹49,999)" icon={IndianRupee}>
                                        <input
                                            name="amount"
                                            type="text"
                                            max={49999}
                                            value={formData.amount}
                                            onChange={handleChange}
                                            readOnly={selectedBillerExactness === "EXACT"}
                                            placeholder="Enter Amount"
                                            className="flex-1 ml-3 bg-transparent outline-none text-slate-900"
                                        />
                                    </InputField>
                                    {amountError && (
                                        <p className="text-xs text-red-500 mt-1">{amountError}</p>
                                    )}
                                </div>

                                <InputField label="MPIN" icon={Lock}>
                                    <input
                                        type="password"
                                        maxLength={6}
                                        value={mpin}
                                        onChange={(e) => setMpin(e.target.value)}
                                        placeholder="6-digit MPIN"
                                        autoComplete="off"
                                        className="flex-1 ml-3 bg-transparent outline-none text-slate-900"
                                    />
                                </InputField>
                            </div>

                            <p className="text-xs text-slate-400 mb-4">{getPaymentInstructionText()}</p>

                            {error && (
                                <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-2xl px-4 py-3 mb-4">
                                    {error}
                                </div>
                            )}

                            <div className="flex gap-3">
                                <button
                                    type="button"
                                    onClick={() => { setBillFetched(false); setBillDetails(null); }}
                                    className="h-14 rounded-2xl flex items-center justify-center flex-1 font-semibold bg-white border border-slate-300 text-slate-700 transition-all duration-200"
                                >
                                    <ArrowLeft size={18} className="mr-2" />
                                    Back
                                </button>

                                <button
                                    type="submit"
                                    disabled={loading}
                                    className={`h-14 rounded-2xl flex items-center justify-center flex-1 transition-all duration-200 ${loading ? "bg-[#12345A] text-white" : "bg-[#12345A] text-white"
                                        }`}
                                >
                                    {loading ? (
                                        <Loader2 size={20} color="#fff" className="animate-spin" />
                                    ) : (
                                        <ShieldCheck size={20} color="#fff" />
                                    )}
                                    <span className="text-white text-base font-bold ml-2">
                                        {loading ? "Processing…" : "Pay Bill"}
                                    </span>
                                </button>
                            </div>
                        </form>
                    </div>
                )}
            </div>

            {/* ── FEE CONFIRMATION POPUP ──────────────────────────────────── */}
            {showFeeConfirmation && feeDetails && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
                    <div className="bg-white w-full max-w-sm rounded-3xl p-5 animate-in zoom-in-95 duration-200">
                        <h3 className="text-xl font-bold text-slate-800 mb-4 text-center">
                            Payment Confirmation
                        </h3>
                        <div className="bg-slate-50 border border-slate-200 rounded-2xl p-4 space-y-3 mb-5">
                            {[
                                ["Bill Amount", `₹${feeDetails.net_amount}`],
                                ["Transaction Fee", `₹${feeDetails.fee}`],
                            ].map(([label, value]) => (
                                <div key={label} className="flex justify-between text-sm">
                                    <span className="text-slate-500">{label}</span>
                                    <span className="font-semibold text-slate-800">{value}</span>
                                </div>
                            ))}
                            <div className="border-t border-slate-200 pt-3 flex justify-between">
                                <span className="font-semibold text-slate-700">Total Amount</span>
                                <span className="font-bold text-blue-600">₹{feeDetails.txn_amount}</span>
                            </div>
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            <button
                                onClick={() => setShowFeeConfirmation(false)}
                                className="h-12 rounded-2xl bg-white border border-slate-300 text-slate-700 font-semibold"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={proceedWithPayment}
                                className="h-12 rounded-2xl bg-[#12345A] text-white font-semibold"
                            >
                                Confirm & Pay
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── PAYMENT RESULT POPUP ────────────────────────────────────── */}
            {paymentResponse && (
                <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
                    <div className="bg-white w-full max-w-sm rounded-3xl p-5 animate-in zoom-in-95 duration-200">

                        {/* normalize status */}
                        {(() => {
                            const status = responseStatus?.toUpperCase();

                            return (
                                <>
                                    <div
                                        className={`w-20 h-20 rounded-full mx-auto flex items-center justify-center mb-4 ${status === "SUCCESS"
                                                ? "bg-green-100"
                                                : status === "PENDING"
                                                    ? "bg-yellow-100"
                                                    : "bg-red-100"
                                            }`}
                                    >
                                        {status === "SUCCESS" ? (
                                            <CheckCircle2 size={34} color="green" />
                                        ) : status === "PENDING" ? (
                                            <Clock3 size={34} color="#CA8A04" />
                                        ) : (
                                            <XCircle size={34} color="red" />
                                        )}
                                    </div>

                                    <h2 className="text-2xl font-bold text-center text-slate-800">
                                        {status === "SUCCESS"
                                            ? "Payment Successful"
                                            : status === "PENDING"
                                                ? "Payment Pending"
                                                : "Payment Failed"}
                                    </h2>

                                    <p className="text-sm text-slate-500 text-center mt-2">
                                        {paymentResponse.message}
                                    </p>

                                    {paymentResponse.txnId && (
                                        <div className="bg-slate-100 rounded-2xl p-3 mt-4">
                                            <p className="text-xs text-slate-500">
                                                Transaction ID
                                            </p>

                                            <p className="font-semibold text-slate-800 break-all">
                                                {paymentResponse.txnId}
                                            </p>
                                        </div>
                                    )}

                                    <button
                                        onClick={closePaymentPopup}
                                        className="mt-5 w-full h-12 rounded-2xl bg-blue-600 text-white font-semibold"
                                    >
                                        Close
                                    </button>
                                </>
                            );
                        })()}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ccbp;


const InputField = ({ label, icon: Icon, children }) => (
    <div>
        <label className="text-slate-800 font-semibold block mb-2">{label}</label>
        <div className="h-14 border border-slate-200 bg-slate-50 rounded-2xl px-4 flex items-center">
            <Icon size={20} color="#64748B" />
            {children}
        </div>
    </div>
);